module.exports = __webpack_public_path__ + "img/r-234.20bf7384.jpg";